import React, {
  Suspense,
  lazy,
  ReactElement,
  ReactNode,
  ComponentType,
  useEffect,
} from "react";
// BrowserRouter as Router
// HashRouter as Router
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useRoutes,
  Navigate,
  Outlet,
  useParams,
  useLocation,
} from "react-router-dom";

// import { HashRouter as Router , Route, Routes, useRoutes, Navigate, Outlet } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import MainLayout from "./MainLayout";
import NotFound from "@/pages/NotFound";
import { arrayObjectToflat } from "@/utils/methods";
import "./index.less";
import { getBrowserLang, i18n_langs } from "@/i18n/config";
import { getStorageLng, setStorageLng } from "@/i18n/storage";


import { getChainsResource } from "@/utils/methods";
import { Spin } from "antd";
import BatchWalletGenerate from "@/pages/BatchWalletGenerate";
import BurnToken from "@/pages/BurnToken";
import IntermediaryTransfer from "@/pages/IntermediaryTransfer";
import ManyToMany from "@/pages/ManyToMany";
import LiquidityCreate from "@/pages/LiquidityCreate";

import AddLiquidity from "@/pages/AddLiquidity";
import BatchSwap from "@/pages/BatchSwap";


// import IntermediaryTransfer from "@/pages/IntermediaryTransfer";
// import WalletTransfer from "@/pages/WalletTransfer";
// import GenerateWalletFromMnemonic from "@/pages/GenerateWalletFromMnemonic"
const Index = lazy(() => import('./../pages/Index'));
const MultiSender = lazy(() => import('../pages/MultiSender'))
const TokenBatchCollection = lazy(() => import('../pages/TokenBatchCollection'))

const TokenCreation = lazy(() => import('../pages/TokenCreation'))
const TokenManagement = lazy(() => import('../pages/TokenManagement'))

// const currentChainsResource:any = getChainsResource();
const { urlSuffix }: any = getChainsResource();

function withLanguageGuard(Component: ComponentType): ComponentType {
  return function LanguageGuard(): ReactElement {
    const { lang } = useParams<{ lang: string }>();
    const location = useLocation();
    const { i18n } = useTranslation();

    useEffect(() => {
      // 只有当 lang 改变时才调用 changeLanguage 并更新缓存
      const normalizedLang = lang?.toLowerCase();
      if (i18n_langs.includes(normalizedLang || "")) {
        i18n.changeLanguage(normalizedLang);
        setStorageLng(normalizedLang); // 更新本地存储中的语言
      }
    }, [lang, i18n]);

    if (!i18n_langs.includes(lang?.toLowerCase() || "")) {
      const browserLang = getBrowserLang();
      console.log("router withLanguageGuard browserLang", browserLang, i18n_langs);
      console.log("location.search", location.search)
      const lang = i18n_langs.includes(browserLang?.toLowerCase()) ? browserLang?.toLowerCase() : "en-us";
      const newPath = location.pathname ? (`/${lang}` + location.pathname + location.search) : (`/${lang}/token-creator/sui`);
      console.log("router withLanguageGuard newPath", newPath);
      return <Navigate to={newPath} replace />;
    }

    return <Component />;
  };
}
// console.log("urlSuffixurlSuffix", urlSuffix)
const RouteChildren: any = [
  // { path: "", label: 'nav.home', element: <TokenCreation /> },
  { index: "/", label: 'nav.home', element: <Index /> },
  { path: 'token-creator/' + urlSuffix, label: 'nav.tokenCreation', element: <TokenCreation /> },
  { path: 'token-management/' + urlSuffix, label: 'nav.tokenCreation', element: <TokenManagement /> },
  { path: 'batch-wallet-generate/' + urlSuffix, label: 'nav.BatchWalletGeneration', element: <BatchWalletGenerate /> },
  { path: 'burn-token/' + urlSuffix, label: 'nav.BatchWalletGeneration', element: <BurnToken /> },
  { path: 'multi-sender/' + urlSuffix, label: 'nav.oneTurnMore', element: <MultiSender /> },
  { path: 'token-batch-collection/' + urlSuffix, label: 'nav.tokenBatchCollection', element: <TokenBatchCollection /> },
  { path: "relay-transfer/" + urlSuffix, label: "nav.transfer", element: <IntermediaryTransfer /> },
  { path: 'multisender-many-to-many/' + urlSuffix, label: 'nav.manyToMany', element: <ManyToMany /> },
  { path: 'create-liquidity-pool/' + urlSuffix, label: 'nav.createLiquidity', element: <LiquidityCreate /> },
  { path: 'add-liquidity-pool/' + urlSuffix, label: 'nav.createLiquidity', element: <AddLiquidity /> },
  { path: 'batch-swap/' + urlSuffix, label: 'nav.batchSwap', element: <BatchSwap /> },
  // /create-liquidity-pool/'
  // { path: 'bsc', element: <Index /> },
  { path: '*', element: <Index /> },
  // { path: '*', element: <Navigate to="/zh-cn/token-creator/sui" replace /> },
]
const GuardedMainLayout = withLanguageGuard(MainLayout);

const RedirectToDefaultLang = () => {
  const location = useLocation();

  // 获取本地存储中的语言
  let storedLang = getStorageLng();

  // 如果本地存储中没有语言，则使用浏览器语言并转换为小写
  if (!storedLang) {
    const browserLang = getBrowserLang();
    storedLang = i18n_langs.includes(browserLang) ? browserLang : "en-us";
    setStorageLng(storedLang || ""); // 更新本地存储
  }

  const redirectPath = `/${storedLang}`;

  // const whiteList = ['multi-sender/bnb', 'token-batch-collection/bnb', 'token-creator/bnb']
  // const accessiblePaths = whiteList.map(path => `/${storedLang}/${path}`);
  // if(!accessiblePaths.includes(location.pathname)){
  //   return <Navigate to={`/${storedLang}/multi-sender/bnb`} replace />;
  // }
  // 进入网站默认跳转批量转账页面
  // if (location.pathname != `/${storedLang}/multi-sender/bnb`) {
  //   return <Navigate to={`/${storedLang}/multi-sender/bnb`} replace />;
  // }

  if (location.pathname === "/") {
    // return <Navigate to={`${storedLang}/token-creator/sui`} replace />;
    return <Navigate to={`/${storedLang}/sui`} replace />;
  }

  return null;
  // return <Navigate to={`/${storedLang}/token-creator/sui`} replace />;
};

const MyRoutes: any = [
  // {
  //   path: '/',
  //   label: 'nav.home',
  //   element: <MainLayout />,
  //   children: RouteChildren
  // },
  {
    path: "/",
    label: "nav.home",
    element: <RedirectToDefaultLang />,
    // element: <GuardedMainLayout />,
    // children: RouteChildren,
  },
  {
    path: "/:lang",
    label: "nav.home",
    element: <GuardedMainLayout />,
    children: RouteChildren,
  },
];

function toRouteInfo(list: any, prexPath: string = "") {
  return list.map((item: any) => {
    let { path, label } = item;
    let children = [];
    let allPath =
      path !== undefined
        ? prexPath === ""
          ? path
          : prexPath + (prexPath === "/" ? "" : "/") + path
        : prexPath;
    // let allPath = item.path
    if (item.children?.length > 0) {
      children = toRouteInfo(item.children, allPath);
    }
    return {
      path: allPath,
      label,
      children,
    };
  });
}
export const routeInfo = arrayObjectToflat(toRouteInfo(MyRoutes), "children");
window.localStorage.setItem("routeInfo", JSON.stringify(routeInfo));
// console.log('routeInfo',routeInfo)

const RouterView = (): ReactElement => {
  const element = useRoutes(MyRoutes);
  return (
    // <Router>
    <Suspense
      fallback={
        <div className="pre-load">
          <Spin className="custom-spin" />
          {/* <img src="/logo.webp" alt="" /> */}
        </div>
      }
    >
      {element}
    </Suspense>
    // </Router>
  );
};

export default RouterView;
